module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter1"
    }
  }, [_vm._v("Usher")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2"
    }
  }, [_vm._v("The Penny Is for God!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tessie, Don’t Give Away the Raisin; without It, You’re Lost!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free the Canaries from Their Cages!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Golden Tombstones for Me!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They’re Killing Jews on Sackman Street!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fire Is Burning on Our Street!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come into the Hallway, for Five Cents!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“When We Produce Prostitutes and Thieves, We Shall Be a Normal People!”—Jabotinsky")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hello, Lenin! Hello, Stalin! How’s the Revolution Today?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Songs My Mother Taught Me That Are Not in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamlet;")]), _vm._v(" or, “Come into My House, Horatio! There Are More Things under the Mattress than Are Dreamt of in Your Philosophy!”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Went to the Market Place to See the World! Oy, Mama, Oy!")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With a Herring in One Hand and a Bottle of Schnapps in the Other; Oh! How He Did Dance!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0